import { useState, useEffect } from "react";

const useIsTablet = () => {
  const getValue = () => {
    if (typeof window === "undefined") return false;

    const hasTouch = navigator.maxTouchPoints > 0;
    const isSmallScreen = window.innerWidth <= 1024;
    const uaMatch = /Mobi|Android|Tablet/i.test(navigator.userAgent);

    return (isSmallScreen || uaMatch) && hasTouch;
  };

  const [isNotDesktop, setIsNotDesktop] = useState(getValue);

  useEffect(() => {
    const handleResize = () => setIsNotDesktop(getValue());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isNotDesktop;
};

export default useIsTablet;
